module.exports = __webpack_public_path__ + "img/illustration-vigne.asset.c73a91eb.svg";